var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLibraryPriceAdultFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 33.3333 33.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.25C10.5167 16.25 9.58333 17.1833 9.58333 18.3333C9.58333 19.4833 10.5167 20.4167 11.6667 20.4167C12.8167 20.4167 13.75 19.4833 13.75 18.3333C13.75 17.1833 12.8167 16.25 11.6667 16.25ZM21.6667 16.25C20.5167 16.25 19.5833 17.1833 19.5833 18.3333C19.5833 19.4833 20.5167 20.4167 21.6667 20.4167C22.8167 20.4167 23.75 19.4833 23.75 18.3333C23.75 17.1833 22.8167 16.25 21.6667 16.25ZM16.6667 0C7.46667 0 0 7.46667 0 16.6667C0 25.8667 7.46667 33.3333 16.6667 33.3333C25.8667 33.3333 33.3333 25.8667 33.3333 16.6667C33.3333 7.46667 25.8667 0 16.6667 0ZM16.6667 30C9.31667 30 3.33333 24.0167 3.33333 16.6667C3.33333 16.1833 3.36667 15.7 3.41667 15.2333C7.35 13.4833 10.4667 10.2667 12.1 6.28333C15.1167 10.55 20.0833 13.3333 25.7 13.3333C27 13.3333 28.25 13.1833 29.45 12.9C29.8 14.0833 30 15.35 30 16.6667C30 24.0167 24.0167 30 16.6667 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLibraryPriceAdultFace);
export default __webpack_public_path__ + "static/media/menu_library_price_adult_face.813426366db749db55ad728dc4f2770f.svg";
export { ForwardRef as ReactComponent };